<template>
  <div>
    <b-card no-body class="mb-1">
      <div class="p-1 d-flex align-items-center justify-content-between flex-wrap" style="gap:.6rem">
        <div>
          <h4 class="mb-0">سجل بطاقات متابعة المعلمين</h4>
          <small class="text-muted">استعرض البطاقات المحفوظة، أو صفّها لمعلم معيّن، أو أنشئ بطاقة جديدة.</small>
        </div>
        <div class="d-flex align-items-center flex-wrap" style="gap:.5rem">
          <b-form-select v-model="filterTeacher" :options="teacherOptions" size="sm" style="min-width:220px" />
          <b-button variant="primary" @click="newCard">
            <feather-icon icon="PlusIcon" /> إنشاء بطاقة جديدة
          </b-button>
          <b-button variant="outline-secondary" size="sm" @click="load" title="تحديث">
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
        </div>
      </div>
    </b-card>

    <b-card no-body>
      <div class="table-responsive mb-0">
        <table class="table table-hover mb-0" style="white-space:nowrap">
          <thead>
            <tr>
              <th>م</th>
              <th>المعلم</th>
              <th>المادة</th>
              <th>تاريخ الزيارة</th>
              <th>الحصة</th>
              <th>رقم الزيارة</th>
              <th>النتيجة</th>
              <th>آخر تحديث</th>
              <th class="text-center">إجراءات</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(c, i) in filteredCards" :key="c.id" style="cursor:pointer" @click="openCard(c.id)">
              <td>{{ i + 1 }}</td>
              <td><strong>{{ c.teacher || '— بدون اسم —' }}</strong></td>
              <td>{{ c.subject || '-' }}</td>
              <td>{{ vdate(c) }}</td>
              <td>{{ c.period || '-' }}</td>
              <td>{{ c.visitno || '-' }}</td>
              <td>
                <b-badge v-if="c.cnt" :variant="resVariant(c.avg)">{{ c.avg }} / 5 · {{ level(c.avg) }}</b-badge>
                <span v-else class="text-muted">—</span>
              </td>
              <td><small class="text-muted">{{ fdate(c.at) }}</small></td>
              <td class="text-center" @click.stop>
                <b-button size="sm" variant="flat-primary" @click="openCard(c.id)" title="فتح / تعديل">
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button size="sm" variant="flat-danger" @click="del(c)" title="حذف">
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </td>
            </tr>
            <tr v-if="!filteredCards.length">
              <td colspan="9" class="text-center text-muted p-3">
                لا توجد بطاقات {{ filterTeacher ? 'لهذا المعلم' : 'بعد' }} — اضغط «إنشاء بطاقة جديدة».
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BButton, BFormSelect, BBadge } from 'bootstrap-vue'
export default {
  components: { BCard, BButton, BFormSelect, BBadge },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      teachers: [],
      cards: [],
      filterTeacher: '',
    }
  },
  computed: {
    teacherOptions() {
      return [{ value: '', text: 'كل المعلمين' }].concat(
        this.teachers.map(t => ({ value: t.name, text: t.name }))
      )
    },
    filteredCards() {
      if (!this.filterTeacher) return this.cards
      return this.cards.filter(c => c.teacher === this.filterTeacher)
    },
  },
  created() {
    if (!checkPer('teachers|view')) {
      this.$router.push('/NotPermitted')
      return false
    }
    this.load()
  },
  methods: {
    load() {
      var g = this
      $.post(api + '/user/teachers/list', { jwt: g.user.jwt }).then(function (r) {
        if (r.status == 100) g.teachers = r.response || []
      })
      $.post(api + '/user/teachers/card/list', { jwt: g.user.jwt }).then(function (r) {
        if (r.status == 100) g.cards = r.response || []
      })
    },
    newCard() {
      var q = this.filterTeacher ? '?teacher=' + encodeURIComponent(this.filterTeacher) : ''
      this.$router.push('/_teachers/card' + q)
    },
    openCard(id) {
      this.$router.push('/_teachers/card?id=' + encodeURIComponent(id))
    },
    del(c) {
      var g = this
      if (!confirm('حذف بطاقة «' + (c.teacher || 'بدون اسم') + '»؟')) return
      $.post(api + '/user/teachers/card/delete', { jwt: g.user.jwt, id: c.id }).then(function (r) {
        if (r.status == 100) {
          g.cards = g.cards.filter(x => x.id !== c.id)
          alert('تم حذف البطاقة', 100)
        }
      })
    },
    vdate(c) {
      if (!c.vd && !c.vm) return '-'
      return (c.vd || '..') + '/' + (c.vm || '..') + '/' + (c.vy || '') + 'هـ'
    },
    level(a) {
      return ['', 'ضعيف', 'مقبول', 'جيد', 'جيد جداً', 'ممتاز'][Math.round(a)] || '-'
    },
    resVariant(a) {
      var r = Math.round(a)
      return r >= 5 ? 'success' : r == 4 ? 'primary' : r == 3 ? 'info' : r == 2 ? 'warning' : 'danger'
    },
    fdate(d) {
      if (!d) return ''
      try { return new Date(d).toLocaleDateString('ar') } catch (e) { return '' }
    },
  },
}
</script>
